import { AnalyticsServiceModule } from '@b2c/common/services/analytics/analytics.service';
import { CalendarServiceModule } from '@b2c/common/services/calendar/calendar.service';
import { HelpersServiceModule } from '@b2c/common/services/helpers/helpers.service';
import angular from 'angular';

export const ReviewDirectiveModule = angular.module('acme.common.directive.review', [
  HelpersServiceModule,
  CalendarServiceModule,
  AnalyticsServiceModule
])
.directive('review', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/review/review.tpl.html',
      scope: {
        model: '=',
        showEvent: '@',
        updateReview: '&'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', '$sce', 'HelpersService', 'CalendarService', 'AnalyticsService', function($scope, $sce, HelpersService, CalendarService, AnalyticsService) {

        $scope.review =  {

          isExpanded: false,
          commentLimit: 300,

          title: '',
          eventName: '',
          createdOn: '',
          shortComment: '',
          safeComment: '',
          visitorIsAuthor: false,

          init: function() {
            this.title = $sce.trustAsHtml(HelpersService.strip($scope.model.title));
            this.eventName = $scope.model.eventName;
            this.visitorIsAuthor = $scope.model.visitorIsAuthor;
            this.safeComment = $sce.trustAsHtml(HelpersService.convertBreaks(HelpersService.strip($scope.model.comment)));
            this.shortComment = $sce.trustAsHtml(HelpersService.strip($scope.model.comment, this.commentLimit));
            this.createdOn = CalendarService.getParsableDate($scope.model.createdOn);
          },

          expand: function() {
            this.isExpanded = true;
            AnalyticsService.event({
              name: 'Review::Expand',
              category: 'Reviews',
              label: 'Review: ' + $scope.model.id + ')'
            });
          },

          showExpand: function() {
            var comment = HelpersService.strip($scope.model.comment, this.commentLimit);
            return (!this.isExpanded && (comment.length > this.commentLimit));
          },

          updateReview: function() {
            if (typeof $scope.updateReview === 'function') {
              $scope.updateReview($scope.model);

              AnalyticsService.event({
                name: 'Review::Update',
                category: 'Reviews',
                label: 'Review: ' + $scope.model.id + ')'
              });
            }
          },

          onEventClick: function(e) {
            $scope.$emit('Review::EventClick', {
              review: $scope.model
            });
            AnalyticsService.event({
              name: 'Review::EventClick',
              category: 'Reviews',
              label: 'Review: ' + $scope.model.id + ')'
            });
          }

        };

        $scope.review.init();

      }]

    };

}]).name;